import * as colors from '../constants/Colors';
import loader from '../assets/image/loader2.svg';

const mainLogoImage = 'https://hcm.paycor.com/pds/logo/corporate/official-paycor-logo-vert.svg';

const colorSchemeSettings = {
    buttons: {
        primary: {
            borderColor: colors.royalBlueDark,
            textColor: '#FFFFFF',
            backgroundColor: colors.royalBlueDark,
        },
        light: {
            borderColor: colors.royalBlueDark,
            textColor: colors.royalBlueDark,
            backgroundColor: '#FFFFFF',
        },
        tertiary: {
            borderColor: '#737373',
            textColor: '#737373',
            backgroundColor: '#ffffff',
        },
    },
    criteriaTagsStyles: {
        mustHave: {
            fontColor: '#1F1853',
            backgroundColor: colors.darkYellow,
            borderColor: colors.darkYellow,
            showIcon: false,
        },
        important: {
            fontColor: '#1F1853',
            backgroundColor: colors.middleYellow,
            borderColor: colors.middleYellow,
            showIcon: false,
        },
        preferred: {
            fontColor: '#1F1853',
            backgroundColor: colors.lightYellow,
            borderColor: colors.lightYellow,
            showIcon: false,
        },
        advantage: {
            fontColor: '#1F1853',
            backgroundColor: colors.paleYellow,
            borderColor: colors.paleYellow,
            showIcon: false,
        },
        problematic: {
            fontColor: '#1F1853',
            borderColor: '#DC1B1B',
            showIcon: true,
        },
        derived: {
            fontColor: '#1F1853',
            showIcon: true,
        },
        excluded: {
            fontColor: '#1F1853',
            backgroundColor: '#e3e3e3',
            borderColor: '#e3e3e3',
            showIcon: false,
        },
        revertedExcluded: {
            fontColor: '#1F1853',
            backgroundColor: '#e3e3e3',
            borderColor: '#e3e3e3',
            showIcon: false,
        },
        loading: {
            backgroundColor: colors.middleYellow,
            borderColor: colors.paleYellow,
        },
        hovered: {
            borderColor: colors.royalBlueDark,
        },
        marked: {
            backgroundColor: colors.whiteSky,
        },
    },
    links: {
        primary: {
            textColor: colors.royalBlueDark,
        },
    },
    dashedComponent: {
        borderColor: '#cbcdd1',
        hover: {
            backgroundColor: '#b6e2f4',
        },
    },
    insights: {
        positive: {
            backgroundColor: '#acd2a2',
        },
        negative: {
            backgroundColor: '#f68d90',
        },
    },
    thumbButtons: {
        positive: {
            color: '#4f903c',
        },
        negative: {
            color: '#ec1b21',
        },
    },
    talentPool: {
        value: {
            color: colors.royalBlueDark,
        },
    },
    ratingStep: {
        active: {
            borderColor: colors.royalBlueDark,
            backgroundColor: colors.white,
        },
        passed: {
            borderColor: colors.royalBlueDark,
            backgroundColor: colors.royalBlueDark,
        },
        notPassed: {
            borderColor: colors.graySmoke,
            backgroundColor: colors.graySmoke,
        },
    },
    highlight: {
        backgroundColor: colors.skyBlue,
    },
    common: {
        text: {
            color: '#000000',
        },
        panel: {
            backgroundColor: colors.graySmoke,
        },
        logo: {
            width: 'auto',
        },
        mainLogo: {
            paycorLogo: mainLogoImage,
        },
    },
    loader: {
        image: loader,
        size: 24,
    },
    squirrelIcons: {
        display: 'none',
    },
};

export default colorSchemeSettings;
